import { DeletePayload } from "./shared/save-request.model";


export class DeletePersonAuthenticationPayload extends DeletePayload {
  items: [{ id: number; type: string }];

  constructor(id: number) {
    super();
    this.items = [
      {
        type: "personAuthentication",
        id: id,
      },
    ];
  }
}

